<template>
  <el-dialog title="修改"
             :visible.sync="dialogFormVisible"
             custom-class="mini-dialog"
             center
             :close-on-click-modal="false"
             :modal="true"
             :append-to-body="true"
  >
    <el-form :model="form" ref="form1">

      <el-row>
        <el-col :span="24" v-if="form.hdtype!='over'">
          <el-form-item label="有效日期" :label-width="formLabelWidth">
            <el-date-picker style="width:260px;"
                            v-model="searchdatevalue"
                            type="daterange" :value-format="'yyyy-MM-dd'"
                            align="left" :unlink-panels="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="form.hdtype=='over'">
          <el-form-item label="作废原因" :label-width="formLabelWidth">
            <el-input v-model="form.remark" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {update} from '@/api/set/machinecoupon';

  export default {
    name: "SaleTimeEdit",
    data() {
      return {
        dialogFormVisible: false,
        formLabelWidth: '120px',
        searchdatevalue: [],//有效期限
        form: {
          unitguid: '',
          begindate: '',//开始时间
          enddate: '',//结束时间
          hdtype:'',
          remark:''
        },
      }
    },
    methods: {
      show(row,type) {
        this.initForm()
        this.form.hdtype=type;
        this.dialogFormVisible = true;
        this.form.unitguid = row.unitguid
        if (row.begindate) {
          this.searchdatevalue[0] = row.begindate
          this.searchdatevalue[1] = row.enddate
        }
      },
      saveData() {
        var f={};

        if(this.form.hdtype=='over'){
          if(!this.form.remark) {
            this.$message({
              message: '原因必填！',
              type: 'error'
            })
            return;
          }

          f = {
            remark: this.form.remark,
            unitguid: this.form.unitguid,
            hdtype:this.form.hdtype
          }
        }else {
          f = {
            begindate: this.searchdatevalue && this.searchdatevalue.length > 0 ? this.searchdatevalue[0] : "",
            enddate: this.searchdatevalue && this.searchdatevalue.length > 0 ? this.searchdatevalue[1] : "",
            unitguid: this.form.unitguid,
            hdtype:'date'
          }
        }

        update(f).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.dialogFormVisible = false;
            //刷新列表
            this.$emit('bindGrid');
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
          this.isDisable = false;
        });

      },
      initForm() {
        this.searchdatevalue = []
        this.dialogFormVisible = false
        this.form.begindate = ''
        this.form.enddate = ''
        this.form.remark=''
      },
    },
    components: {}
  }
</script>






// WEBPACK FOOTER //
// src/components/set/salefavour/SaleTimeEdit.vue